import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'components/Icon';

import './style.scss';

const Header = ({ title, onClose, children }) => {
  return (
    <header className="page-header">
      <div className="title-wrapper">
        <div className="title title-header">{title}</div>
        {children && <div className="header-children">{children}</div>}
      </div>
      <div className="page-close" onClick={onClose}>
        <Icon name="close" />
      </div>
    </header>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.element,
};

Header.defaultProps = {
  onClose: () => {},
};

export { Header };
